import React from 'react';
import { GoSignIn, GoSignOut } from 'react-icons/go';
import { Button } from 'reactstrap';

import { sessionShape } from '../../prop-types';
import openSignInDialog from '../../signin/dialog/open';
import withSessionInfo from '../../signin/with-session-info';
import * as Session from '../../utils/session';

function signOut() {
  Session.clear();
}

function signIn() {
  openSignInDialog();
}

function SignOutButton({ session }) {
  if (session) {
    return (
      <Button color="black" className="ml-2 btn-block" onClick={signOut}>
        Log Out <GoSignOut />
      </Button>
    );
  }

  return (
    <Button color="link" className="nav-link ml-2" onClick={signIn}>
      <GoSignIn />
    </Button>
  );
}

SignOutButton.propTypes = {
  session: sessionShape,
};

SignOutButton.defaultProps = {
  session: null,
};

export default withSessionInfo(SignOutButton);
